<template>
  <div>
    <v-toolbar color="pink" dark>
      <v-icon>list</v-icon>
      <v-toolbar-title>Team User Accounts</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template slot="activator">
          <v-btn :to="{name:'club-creator'}">
            <v-icon>add</v-icon>
          </v-btn>
        </template>
        <span>Create new account</span>
      </v-tooltip>
    </v-toolbar>
    <v-card>
      <v-data-table :headers="ui.headers" :loading="ui.loading" :items="clubs" class="elevation-1" :pagination.sync="page" :total-items="page.totalItems">
        <template v-slot:items="props">
          <td>{{ props.item.name }}</td>
          <td>{{ props.item.location }}</td>
          <td>{{props.item.identity.username }}</td>
          <td>
            <v-btn icon :to="{name:'club-editor',params:{id:props.item.id}}">
              <v-icon>edit</v-icon>
            </v-btn>
            <v-menu offset-x v-if="options.showDeleteOption">
              <template v-slot:activator="{ on }">
                <v-btn icon small v-on="on">
                  <v-icon>delete</v-icon>
                </v-btn>
              </template>
              <v-toolbar color="pink" dark>
                <v-icon>delete</v-icon>
                <v-toolbar-title>Confirm deletion</v-toolbar-title>
              </v-toolbar>
              <v-card>
                <v-card-title>
                  <v-layout row wrap>
                    <v-flex xs12>
                      <div text-center>Are you sure you want to delete this record? This cannot be undone!</div>
                    </v-flex>
                  </v-layout>
                </v-card-title>
                <v-card-actions>
                  <v-btn block>No</v-btn>
                  <v-btn block @click="deleteClub(props.item.id)">Yes</v-btn>
                </v-card-actions>
              </v-card>
            </v-menu>
          </td>
        </template>
      </v-data-table>
    </v-card>
    <v-snackbar auto-height v-model="ui.showAlert" color="error" :timeout="600000">
      <span>{{ui.feedback}}</span>
      <v-btn dark flat @click="ui.showAlert = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import _ from "underscore";
import { mapState } from "vuex";

export default {
  data: function() {
    return {
      clubs: [],
      page: {
        page: 1,
        rowsPerPage: 10,
        totalItems: 0,
        hasNextPage: false,
        hasPreviousPage: false
      },
      ui: {
        loading: false,
        showAlert: false,
        feedback: "",
        headers: [
          {
            text: "Name",
            value: "name",
            sortable: false,
            align: "left"
          },
          {
            text: "Location",
            value: "location",
            sortable: false,
            align: "left"
          },
          {
            text: "Username",
            value: "identity.username",
            sortable: false,
            align: "left"
          },
          {
            text: "Options",
            sortable: false,
            align: "left",
            width: "200px"
          }
        ]
      }
    };
  },
  watch: {
    "page.page": function(n, o) {
      if (n !== o) this.reload();
    },
    "page.rowsPerPage": function(n, o) {
      if (n !== o) this.reload();
    }
  },
  mounted: function() {
    this.reload();
  },
  methods: {
    reload: function() {
      var me = this;
      me.ui.loading = true;
      this.$api("clubs")
        .get({ page: this.page.page, pageSize: this.page.rowsPerPage })
        .then(function(resp) {
          me.clubs = resp.items;
          me.page = _.omit(resp, "items");
        })
        .catch(function() {})
        .finally(function() {
          me.ui.loading = false;
        });
    },
    deleteClub: function(id) {
      var me = this;
      me.ui.feedback = "";
      me.ui.showAlert = false;
      this.$api("clubs/" + id)
        .delete()
        .then(function() {
          var index = _.findIndex(me.clubs, function(x) {
            return x.id == id;
          });
          if (index >= 0) {
            me.clubs.splice(index, 1);
          }
        })
        .catch(function(xhr) {
          if (xhr && xhr.responseJSON && xhr.responseJSON.feedback) {
            me.ui.feedback = xhr.responseJSON.feedback;
          } else {
            me.ui.feedback = "An error occured";
          }
          me.ui.showAlert = true;
        });
    }
  },
  computed: {
    ...mapState("config", ["options"])
  }
};
</script>

<style>
</style>
